var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"social-nav"},_vm._l((_vm.socialNetworks),function(s){return _c('li',{key:s.name},[_c('a',{attrs:{"href":s.link,"target":"_blank"}},[_c('i',{class:("fa fa-" + (s.iconClassName))})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }